// extracted by mini-css-extract-plugin
module.exports = {"decoratedText":"FullDealCalculationsMinimal_decoratedText__28dNx","badge":"FullDealCalculationsMinimal_badge__30uKS"};